import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ThroughOptionPage } from '../../modals/through-option/through-option.page';

@Injectable({
  providedIn: 'root',
})
export class ThroughOptionService {
  constructor(public modalController: ModalController) {}

  async showModal(optionParam, canFillPreviousCredential = false) {
    const modal = await this.modalController.create({
      component: ThroughOptionPage,
      componentProps: {
        option: optionParam,
        canFillPreviousCredential,
      },
      cssClass: 'wg-modal ' + (optionParam === 'register' ? /* istanbul ignore next */ 'signup-modal' : 'login-modal'),
      swipeToClose: true,
      backdropDismiss: true,
    });
    return await modal.present();
  }

  async closeModal() {
    await this.modalController.dismiss();
  }
}
